import { render, staticRenderFns } from "./maintenance_record_item.vue?vue&type=template&id=45e64e28&"
import script from "./maintenance_record_item.vue?vue&type=script&lang=js&"
export * from "./maintenance_record_item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports